import React, { useState } from "react";
import "./Portal.css";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faYoutube, faInstagram } from "@fortawesome/free-brands-svg-icons";

import { useSpring, animated } from "@react-spring/web";

const Portal = () => {
    const [menuVisible, setMenuVisible] = useState(false);
    const [isRotated, setIsRotated] = useState(false);
    const [hoveredCard, setHoveredCard] = useState(null);

    const logoInsani = useSpring({
        transform: isRotated ? "rotate(360deg)" : "rotate(0deg)",
        config: { duration: 800 },
        cursor: "pointer",
    });

    const toggleMenu = () => {
        setMenuVisible(!menuVisible);
        setIsRotated(!isRotated);
    };

    const handleCardHover = (text) => {
        setHoveredCard(text);
    };

    const handleCardLeave = () => {
        setHoveredCard(null);
    };

    return (
        <div className="single-page-container text-center">
            {/* Header */}
            {/* <header className="header">
        <animated.div style={logoAnimation}>
          <img
            src="/assets/logo-Ykbut.png"
            alt="Logo ykbut"
            className="logo-ykbut"
          />
        </animated.div>
      </header> */}

            {/* Main Content */}
            <main className="main">
                <section className="section">
                    <div className="content">
                        <h1 className="title">Welcome To Portal</h1>

                        <img
                            src="/assets/logo-Ykbut.png"
                            alt="Logo ykbut"
                            className="logo-ykbut"
                            style={{ marginLeft: "30px" }}
                        />
                    </div>

                    <div className="container">
                        <animated.div
                            className="logo-insani"
                            onClick={toggleMenu}
                            style={logoInsani}
                        >
                            <img
                                src="/assets/logo-peduli-insani3.png"
                                alt="logo"
                                className="peduli-insani"
                            />
                        </animated.div>

                        {menuVisible && (
                            <div className="menu">
                                <Card
                                    style={{
                                        backgroundColor: "transparent",
                                        border: "none",
                                    }}
                                    className="inovy mx-auto"
                                    onMouseEnter={() => handleCardHover("Inovy")}
                                    onMouseLeave={handleCardLeave}
                                >
                                    <a
                                        href="https://inovy.ykbut.co.id/"
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        style={{ textDecoration: "none" }}
                                    >
                                        <div className="inline-inovy">
                                            <div>
                                                <img
                                                    variant="top"
                                                    src="/assets/inovy.png"
                                                    className="card-img1"
                                                    alt="img-inovy"
                                                    // style={{ '--delay': '0.7s' }}
                                                />
                                            </div>
                                            <p>INOVY</p>
                                            {hoveredCard === "Inovy" && (
                                                <Card
                                                    style={{
                                                        backgroundColor: "white",

                                                        transform: "translate(5%, -350%)",
                                                    }}
                                                    className="hovered-card mx-auto"
                                                >
                                                    <p className="info" style={{ color: "black" }}>
                                                        Inovasi YKBUT
                                                    </p>
                                                </Card>
                                            )}
                                        </div>
                                    </a>
                                </Card>

                                <Card
                                    style={{
                                        backgroundColor: "transparent",
                                        border: "none",
                                    }}
                                    className="boomer mx-auto"
                                    onMouseEnter={() => handleCardHover("Boomer")}
                                    onMouseLeave={handleCardLeave}
                                >
                                    <a
                                        href="https://boomer.ykbut.co.id/"
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        style={{ textDecoration: "none" }}
                                    >
                                        <div className="inline-boomer">
                                            <div>
                                                <img
                                                    variant="top"
                                                    className="card-img2"
                                                    src="/assets/BOOMER.png"
                                                    alt="img-boomer"
                                                    style={{ "--delay": "0.7s" }}
                                                />
                                            </div>
                                            <p>Boomer</p>
                                            {hoveredCard === "Boomer" && (
                                                <Card
                                                    style={{
                                                        backgroundColor: "white",

                                                        transform: "translate(100%, -180%)",
                                                    }}
                                                    className="hovered-card mx-auto"
                                                >
                                                    <p className="info" style={{ color: "black" }}>
                                                        Booking Meeting Room
                                                    </p>
                                                </Card>
                                            )}
                                        </div>
                                    </a>
                                </Card>

                                <Card
                                    style={{
                                        backgroundColor: "transparent",
                                        border: "none",
                                    }}
                                    className="toca mx-auto"
                                    onMouseEnter={() => handleCardHover("ToCA")}
                                    onMouseLeave={handleCardLeave}
                                >
                                    <a
                                        href="https://toca.ykbut.co.id/"
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        style={{ textDecoration: "none" }}
                                    >
                                        <div className="inline-toca">
                                            <div>
                                                <img
                                                    variant="top"
                                                    className="card-img3"
                                                    src="/assets/ToCA2.png"
                                                    alt="img-toca"
                                                    // style={{ '--delay': '0.7s' }}
                                                />
                                            </div>
                                            <p className="p-toca">ToCA</p>
                                            {hoveredCard === "ToCA" && (
                                                <Card
                                                    style={{
                                                        backgroundColor: "white",

                                                        transform: "translate(125%, -150%)",
                                                    }}
                                                    className="hovered-card mx-auto"
                                                >
                                                    <p className="info" style={{ color: "black" }}>
                                                        Tools of Culture Assessment
                                                    </p>
                                                </Card>
                                            )}
                                        </div>
                                    </a>
                                </Card>

                                <Card
                                    style={{
                                        backgroundColor: "transparent",
                                        border: "none",
                                    }}
                                    className="wbs mx-auto"
                                    onMouseEnter={() => handleCardHover("WBS")}
                                    onMouseLeave={handleCardLeave}
                                >
                                    <a
                                        href="https://ykbut.co.id/PedomanWhistleBlowerYKBUTR12024.pdf"
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        style={{ textDecoration: "none" }}
                                    >
                                        <div className="inline-wbs">
                                            <div>
                                                <img
                                                    variant="top"
                                                    className="card-img4"
                                                    src="/assets/WBS.png"
                                                    alt="img-wbs"
                                                    // style={{ '--delay': '0.7s' }}
                                                />
                                            </div>
                                            <p className="p-wbs">WBS</p>
                                            {hoveredCard === "WBS" && (
                                                <Card
                                                    style={{
                                                        backgroundColor: "white",

                                                        transform: "translate(115%, -180%)",
                                                    }}
                                                    className="hovered-card mx-auto"
                                                >
                                                    <p className="info" style={{ color: "black" }}>
                                                        Whistle Blowing System
                                                    </p>
                                                </Card>
                                            )}
                                        </div>
                                    </a>
                                </Card>

                                <Card
                                    style={{
                                        backgroundColor: "transparent",
                                        border: "none",
                                        transitionDuration: "100s",
                                    }}
                                    className="kopkar mx-auto"
                                    onMouseEnter={() => handleCardHover("Kopkar")}
                                    onMouseLeave={handleCardLeave}
                                >
                                    <a
                                        href="https://kopkarkita.ykbut.co.id/"
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        style={{ textDecoration: "none" }}
                                    >
                                        <div className="inline-kopkar">
                                            <div>
                                                <img
                                                    variant="top"
                                                    className="card-img5"
                                                    src="/assets/kopkar2.png"
                                                    alt="img-kopkar"
                                                    // style={{ '--delay': '0.7s' }}
                                                />
                                            </div>
                                            <p className="p-kopkar">Kopkar YKBUT</p>
                                            {hoveredCard === "Kopkar" && (
                                                <Card
                                                    style={{
                                                        backgroundColor: "white",

                                                        transform: "translate(0%, -395%)",
                                                    }}
                                                    className="hovered-card mx-auto"
                                                >
                                                    <p className="info" style={{ color: "black" }}>
                                                        Kopkar YKBUT
                                                    </p>
                                                </Card>
                                            )}
                                        </div>
                                    </a>
                                </Card>

                                <Card
                                    style={{
                                        backgroundColor: "transparent",
                                        border: "none",
                                    }}
                                    className="it mx-auto"
                                    onMouseEnter={() => handleCardHover("It")}
                                    onMouseLeave={handleCardLeave}
                                >
                                    <a
                                        href="https://itsm.ykbut.co.id/"
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        style={{ textDecoration: "none" }}
                                    >
                                        <div className="inline-it">
                                            <div>
                                                <img
                                                    variant="top"
                                                    className="card-img6"
                                                    src="/assets/it_helpdesk2.png"
                                                    alt="img-it"
                                                    // style={{ '--delay': '0.7s' }}
                                                />
                                            </div>
                                            <p className="p-it">IT Helpdesk</p>
                                            {hoveredCard === "It" && (
                                                <Card
                                                    style={{
                                                        backgroundColor: "white",

                                                        transform: "translate(-115%, -150%)",
                                                    }}
                                                    className="hovered-card mx-auto"
                                                >
                                                    <p className="info" style={{ color: "black" }}>
                                                        IT Helpdesk
                                                    </p>
                                                </Card>
                                            )}
                                        </div>
                                    </a>
                                </Card>

                                <Card
                                    style={{
                                        backgroundColor: "transparent",
                                        border: "none",
                                    }}
                                    className="cla mx-auto"
                                    onMouseEnter={() => handleCardHover("CLA")}
                                    onMouseLeave={handleCardLeave}
                                >
                                    <a
                                        href="https://cla.ykbut.co.id/web/login"
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        style={{ textDecoration: "none" }}
                                    >
                                        <div className="inline-cla">
                                            <div>
                                                <img
                                                    variant="top"
                                                    className="card-img7"
                                                    src="/assets/CLA.png"
                                                    alt="img-cla"
                                                    // style={{ '--delay': '0.7s' }}
                                                />
                                            </div>
                                            <p className="p-cla">CLA</p>
                                            {hoveredCard === "CLA" && (
                                                <Card
                                                    style={{
                                                        backgroundColor: "white",

                                                        transform: "translate(-110%, -140%)",
                                                    }}
                                                    className="hovered-card mx-auto"
                                                >
                                                    <p className="info" style={{ color: "black" }}>
                                                        Commitment Letter Agreement
                                                    </p>
                                                </Card>
                                            )}
                                        </div>
                                    </a>
                                </Card>

                                <Card
                                    style={{
                                        backgroundColor: "transparent",
                                        border: "none",
                                    }}
                                    className="smartco mx-auto"
                                    onMouseEnter={() => handleCardHover("Smartco")}
                                    onMouseLeave={handleCardLeave}
                                >
                                    <a
                                        href="https://smartco.ykbut.co.id/"
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        style={{ textDecoration: "none" }}
                                    >
                                        <div className="inline-smartco">
                                            <div>
                                                <img
                                                    variant="top"
                                                    className="card-img8"
                                                    src="/assets/smartco1.png"
                                                    alt="img-smartco"
                                                    // style={{ '--delay': '0.7s' }}
                                                />
                                            </div>
                                            <p className="p-smartco">Smartco</p>
                                            {hoveredCard === "Smartco" && (
                                                <Card
                                                    style={{
                                                        backgroundColor: "white",

                                                        transform: "translate(-105%, -180%)",
                                                    }}
                                                    className="hovered-card mx-auto"
                                                >
                                                    <p className="info" style={{ color: "black" }}>
                                                        Smartco
                                                    </p>
                                                </Card>
                                            )}
                                        </div>
                                    </a>
                                </Card>
                            </div>
                        )}
                    </div>
                </section>
            </main>

            {/* Footer */}
            <footer className="footer">
                <div className="container">
                    <div className="row">
                        <div className="social-icons">
                            <a href="https://m.facebook.com/ykbutofficial/" className="text-link">
                                <FontAwesomeIcon
                                    icon={faFacebook}
                                    size="2x"
                                    style={{ color: "#ffffff" }}
                                    className="icon"
                                />
                            </a>

                            <a
                                href="https://www.youtube.com/@ykbutofficial3370"
                                className="text-link"
                            >
                                <FontAwesomeIcon
                                    icon={faYoutube}
                                    size="2x"
                                    style={{ color: "#ffffff" }}
                                />
                            </a>

                            <a
                                href="https://www.instagram.com/ykbutofficial/"
                                className="text-link"
                            >
                                <FontAwesomeIcon
                                    icon={faInstagram}
                                    size="2x"
                                    style={{ color: "#ffffff" }}
                                />
                            </a>
                            <span className="teks">@ykbutofficial</span>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Portal;
